<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" v-if="this.model" class="d-flex flex-row-reverse">
        <v-btn :to="'/products/label/'+model.id">Print Label</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="this.model" justify-space-around row fill-height>
      <v-col cols="4">
        <v-row>
          <v-col>
            <v-card class="mb-4 pa-4">
              <v-card-title>
                Product Detail
                <v-spacer />
                <product-form :product="model" @update="refresh" />
              </v-card-title>
              <v-card-text class="pa-0">
                <v-list dense>
                  <v-list-item>
                    <v-list-item-content>Name:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">
                      <v-edit-dialog :return-value.sync="model.name" @save="saveName">
                        {{ model.name }}
                        <template v-slot:input>
                          <v-text-field v-model="model.name" label="Edit" single-line counter></v-text-field>
                        </template>
                      </v-edit-dialog>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Type:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">{{ model.type }}</v-list-item-content>
                  </v-list-item>
                  
                  <v-list-item>
                    <v-list-item-content>Code:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">{{ model.code }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Sku:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">{{ model.sku }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Brand:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">{{ model.brand }}</v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="model.cost != null">
                    <v-list-item-content>Cost:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">
                      {{ model.cost + " " + model.costCurrency}}
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>Low Stock Limit</v-list-item-content>
                    <v-list-item-content>{{ model.low_stock_limit }}</v-list-item-content>
                  </v-list-item>
                  
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Set</v-card-title>
              <v-card-text>
                <v-list-item>
                    <v-list-item-content>Set:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">
                      {{
                      model.set ? model.set.name : "not in set"
                      }}
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-btn icon @click="editSet()">
                        <v-icon color="grey lighten-1">mdi-pencil</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Fields</v-card-title>
              <v-card-text>
                <v-list v-if="model.fields.length" dense>
                  <v-list-item v-for="field in model.fields" :key="field.id">
                    <v-list-item-content>{{ field.handle }}:</v-list-item-content>
                    <v-list-item-content class="align-end font-weight-bold">{{ field.value }}</v-list-item-content>
                  </v-list-item>
                </v-list>
                <div v-else>No fields</div>
              </v-card-text>
              <v-card-actions>
                <add-product-field :product="model" @saved="(product) => model = Object.assign({}, product)"/>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        
      </v-col>
      <v-col cols="8" mr-4>
        <v-row>
          <v-col>
            <v-card>
              <v-card-title>Catalogs</v-card-title>
              <v-card-text>
                <v-expansion-panels>
                  <v-expansion-panel v-for="catalog in catalogs" v-bind:key="catalog.id">
                    <v-expansion-panel-header>
                      {{ catalog.name }}
                      <v-spacer />
                      {{isInCatalog(catalog.id)?'Available':'Not Available'}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="grey lighten-3 pt-4">
                      <template v-if="isInCatalog(catalog.id)">
                        <v-row row wrap>
                          <v-col cols="4">
                            <prices-list :product="model" :catalogId="catalog.id"></prices-list>
                          </v-col>
                          <v-col cols="4" v-if="model.isHead">
                            <prices-list :product="model" :catalogId="catalog.id" :assembled="true"></prices-list>
                          </v-col>
                          <v-col cols="4">
                            <v-card flat>
                              <v-card-title>Options</v-card-title>
                              <v-card-text>
                                <v-col xs12>
                                  <catalog-base-product :catalog="getCatalog(catalog.id)"></catalog-base-product>
                                </v-col>
                              </v-card-text>
                            </v-card>
                          </v-col>
                          <v-col
                            md12
                            lg12
                            ma-2
                            v-if="
                                  model.baseProducts.length &&
                                    model.baseProducts[catalog.id] &&
                                    model.baseProducts[catalog.id].length
                                "
                          >
                            <v-card flat>
                              <v-card-title>Base products</v-card-title>
                              <v-card-text>
                                <v-list dense>
                                  <v-list-item
                                    v-for="product in model.baseProducts[catalog.id]"
                                    :key="product.id"
                                  >
                                    <v-list-item-content>{{ product.name }}</v-list-item-content>
                                    <v-list-item-content class="align-end font-weight-bold">
                                      <v-btn icon @click.stop="openProduct(product.id)">
                                        <v-icon>mdi-arrow-left</v-icon>
                                      </v-btn>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                        <v-btn color="primary" @click="handleRemoveToCatalog(catalog.id)">Remove from catalog</v-btn>
                      </template>
                      <template v-else>
                        <v-btn color="primary" @click="handleAddToCatalog(catalog.id)">Add to catalog</v-btn>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <product-stock-list v-model="model" @refresh="refresh"></product-stock-list>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <product-set-form
      v-if="model"
      :item="productSet"
      :open="setEdit"
      :productId="model.id"
      v-on:cancel="setEdit = false"
      v-on:associated="associateSet()"
    ></product-set-form>
  </v-container>
</template>

<script>
import ProductForm from "../../components/products/ProductForm.vue";
import ProductSetForm from "./_productSetForm.vue";
import PricesList from "@components/products/PricesList.vue";
import CatalogBaseProduct from "@components/products/CatalogBaseProduct.vue";
import ProductStockList from '../../components/products/ProductStockList.vue';
import { mapActions, mapGetters } from 'vuex';
import AddProductField from '../../components/products/AddProductField.vue';
export default {
  components: {
    PricesList,
    CatalogBaseProduct,
    ProductSetForm,
    ProductStockList,
    AddProductField,
    ProductForm
  },
  data: function() {
    return {
      model: null,
      setEdit: false,
      productSet: null
    };
  },
  computed: {
    ...mapGetters("catalogs",["catalogs"])
  },
  watch: {
    $route() {
      if (this.$route.params.id) {
        this.getProduct(this.$route.params.id);
      } else {
        this.$route.push("/product");
      }
    }
  },
  mounted: function() {
    if (this.$route.params.id) {
      this.getProduct(this.$route.params.id);
    } else {
      this.$route.push("/product");
    }
  },
  methods: {
    ...mapActions("products", ["addToCatalog", "removeToCatalog"]),
    refresh() {
      this.getProduct(this.model.id);
    },
    getProduct(id) {
      this.$store
        .dispatch("products/get", {
          id: id
        })
        .then(({data}) => (this.model = data));
    },
    handleAddToCatalog(catalogId) {
      this.addToCatalog({
          id: this.model.id,
          catalogId: catalogId
        })
        .then(() => {
          this.$router.go();
        });
    },
    handleRemoveToCatalog(catalogId) {
      this.removeToCatalog({
          id: this.model.id,
          catalogId: catalogId
        })
        .then(data => (this.model = data.product));
    },
    getCatalog(catalogId) {
      for (let index = 0; index < this.model.catalogs.length; index++) {
        const catalog = this.model.catalogs[index];
        if (catalog.catalog_id == catalogId && catalog.disabled == 0) return catalog;
      }
      return false;
    },
    isInCatalog(catalogId) {
      return this.model.catalogs && this.getCatalog(catalogId);
    },
    openProduct(id) {
      this.$router.push("/products/view/" + id);
    },
    saveName() {
      this.loading = true;
      this.$store
        .dispatch("products/update", {
          model: this.model
        })
        .then(({product}) => (this.model = product))
        .finally(() => {
          this.$store.dispatch("app/displaySnackBar", {
            text: "Product updated",
            color: "#28a745"
          });
        });
    },
    editSet() {
      this.productSet = this.model.set;
      this.setEdit = true;
    },
    associateSet() {
      this.setEdit = false;
      this.refresh();
    }
  }
};
</script>

<style></style>
